<template>
  <b-col class="news-content-container">
    <b-row>
      <b-col class="p-0">
        <h2 class="pl-sm-5 pt-4">Articles</h2>
      </b-col>
    </b-row>

    <b-row>
      <b-col class="p-0">
        <b-nav tabs class="pl-sm-5 pr-sm-5">
          <b-nav-item :to="{ name: 'addArticle'}" exact>Add</b-nav-item>
          <b-nav-item :to="{ name: 'articles'}" exact>Articles</b-nav-item>
        </b-nav>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
export default {
  name: 'ArticlesTab'
}
</script>



// WEBPACK FOOTER //
// src/components/ArticlesTab.vue